import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    id = 0,
    cate = '',
    title = '',
    value = '',
    summary = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.dictionary.save, {
        id,
        cate,
        value,
        title,
        summary,
    }, options);
    if (error) return { error, status };
    return content || { id };
};

